import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

import { isGamesTheme } from "@utils";
import { useRootAppStore } from "@hooks";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";
import { Modal } from "@lib/modal";
import PromoContentImage from "@components/icons/PromoContentImage";
import ResponsibleGamingConfirmationPopup from "@components/footer/mobile/components/ResponsibleGamingConfirmationPopup";

export default function GamesMenuOption() {
	const { t } = useTranslation();

	const { userAuthStore } = useRootAppStore();
	const { handleGamesRedirection } = useGamesNavigation();

	const handleCasinoClick = () => {
		if (
			userAuthStore.isLoggedIn &&
			userAuthStore.user &&
			userAuthStore.isInternetUser
		) {
			setIsResponsibleGamingConfirmationPopupOpened(true);
		} else {
			handleGamesRedirection();
		}
	};

	if (isGamesTheme()) {
		return null;
	}

	if (!WEBPACK_IS_GAMES_ENABLED) {
		return null;
	}

	const [
		isResponsibleGamingConfirmationPopupOpened,
		setIsResponsibleGamingConfirmationPopupOpened,
	] = useState(false);

	return (
		<>
			<div
				className="sidebar__section"
				onClick={() => handleCasinoClick()}
			>
				<div className="sidebar__ad card">
					<PromoContentImage
						page="user-menu-options"
						wrapperClassName="sidebar__ad__picture"
						className="sidebar__ad__img"
						image="login-1.png"
						fallback="membership.png"
					/>

					<div className="sidebar__ad__header card__header">
						<ReactMarkdown>TIPWIN GAMES</ReactMarkdown>
					</div>

					<div className="sidebar__ad__body card__body u-padd--y--reset">
						<ReactMarkdown>
							{t("specific:INFO_PAGES.GAMES.DESCRIPTION")}
						</ReactMarkdown>
					</div>

					<div className="sidebar__ad__footer card__footer">
						<div className="sidebar__ad__btn btn btn--sml btn--block btn--secondary--inverted btn--icon">
							<span className="btn__label u-type--sml">
								{t("specific:INFO_PAGES.GAMES.PLAY_BUTTON")}
							</span>
							<i className="u-icon u-icon--tny u-icon--arrow-right u-color--core--snow" />
						</div>
					</div>
				</div>
			</div>

			<Modal>
				<ResponsibleGamingConfirmationPopup
					flag={isResponsibleGamingConfirmationPopupOpened}
					setFlag={setIsResponsibleGamingConfirmationPopupOpened}
				/>
			</Modal>
		</>
	);
}
